export const CHECKOUT = "[CHECKOUT]";

export const LOADED_PAGE = `${CHECKOUT} LOADED_PAGE`;

export const FETCH_DATA_INFORMATION = `${CHECKOUT} FETCH_DATA_INFORMATION`;
export const FETCH_DATA_SHIPPING = `${CHECKOUT} FETCH_DATA_SHIPPING`;
export const FETCH_DATA_BILLING = `${CHECKOUT} FETCH_DATA_BILLING`;
export const FETCH_DATA_PAYMENT = `${CHECKOUT} FETCH_DATA_PAYMENT`;
export const FETCH_PAYMENTS = `${CHECKOUT} FETCH_PAYMENTS`;
export const FETCH_DATA_SUCCESS = `${CHECKOUT} FETCH_DATA_SUCCESS`;
export const FETCH_SHIPPING_TYPE_RATES = `${CHECKOUT} FETCH SHIPPING TYPE RATES`;
export const FETCH_UPDATED_SHIPPING_TYPE_RATES = `${CHECKOUT} FETCH UPDATED SHIPPING TYPE RATES`;
export const FETCH_SHIPPING_TYPE_BRANCHES = `${CHECKOUT} FETCH SHIPPING TYPE BRANCHES`;
export const FETCH_ADDRESS_FOR_BRANCH_SEARCH = `${CHECKOUT} FETCH ADDRESS FOR BRANCH SEARCH`;

export const SAVE_INFORMATION = `${CHECKOUT} SAVE_INFORMATION`;
export const SAVE_SHIPPING = `${CHECKOUT} SAVE_SHIPPING`;
export const SAVE_BILLING = `${CHECKOUT} SAVE_BILLING`;
export const SAVE_PAYMENT = `${CHECKOUT} SAVE_PAYMENT`;
export const SAVE_EMAIL = `${CHECKOUT} SAVE_EMAIL`;
export const SAVE_PHONE = `${CHECKOUT} SAVE_PHONE`;

export const PLACE_ORDER = `${CHECKOUT} PLACE_ORDER`;

export const STRIPE_INTENT = `${CHECKOUT} STRIPE_INTENT`;

export const SET_DATA = `${CHECKOUT} SET_DATA`;
export const SET_DATA_WITH_BRANCHES = `${CHECKOUT} SET_DATA_WITH_BRANCHES`;

export const UPDATE_INFORMATION = `${CHECKOUT} UPDATE_INFORMATION`;
export const UPDATE_SHIPPING = `${CHECKOUT} UPDATE_SHIPPING`;
export const UPDATE_SHIPPING_OPTION = `${CHECKOUT} UPDATE_SHIPPING_OPTION`;
export const UPDATE_BILLING = `${CHECKOUT} UPDATE_BILLING`;
export const UPDATE_PAYMENT = `${CHECKOUT} UPDATE_PAYMENT`;
export const UPDATE_SUMMARY = `${CHECKOUT} UPDATE_SUMMARY`;
export const UPDATE_COUNTRY = `${CHECKOUT} UPDATE_COUNTRY`;
export const UPDATE_REGION = `${CHECKOUT} UPDATE_REGION`;
export const UPDATE_LOCATIONS = `${CHECKOUT} UPDATE_LOCATIONS`;
export const UPDATE_LOCATIONS_BILLING = `${CHECKOUT} UPDATE_LOCATIONS_BILLING`;
export const UPDATE_PAYMENT_METHOD = `${CHECKOUT} UPDATE_PAYMENT_METHOD`;
export const CALL_ADDRESS_AUTOFILL = `${CHECKOUT} CALL_ADDRESS_AUTOFILL`;
export const SET_ADDRESS_AUTOFILL = `${CHECKOUT} SET_ADDRESS_AUTOFILL`;

export const UPDATE_COUNTRY_BILLING = `${CHECKOUT} UPDATE_COUNTRY_BILLING`;
export const UPDATE_REGION_BILLING = `${CHECKOUT} UPDATE_REGION_BILLING`;

export const SET_FIELD_INFORMATION = `${CHECKOUT} SET_FIELD_INFORMATION`;
export const SAVE_SHIPPING_OPTION = `${CHECKOUT} SAVE_SHIPPING_OPTION`;
export const SET_CUSTOM_FIELD_INFORMATION = `${CHECKOUT} SET_CUSTOM_FIELD_INFORMATION`;
export const SET_FIELD_SHIPPING = `${CHECKOUT} SET_FIELD_SHIPPING`;
export const SET_FIELD_BILLING = `${CHECKOUT} SET_FIELD_BILLING`;
export const GET_PICKUP_PRICE = `${CHECKOUT} GET_PICKUP_PRICE`;
export const GET_PICKUP_PRICE_OLD = `${CHECKOUT} GET_PICKUP_PRICE_OLD`;
export const SET_FIELD_PAYMENT = `${CHECKOUT} SET_FIELD_PAYMENT`;
export const SET_FIELDS_LOCATIONS = `${CHECKOUT} SET_FIELDS_LOCATIONS`;
export const SET_FIELDS_LOCATIONS_BILLING = `${CHECKOUT} SET_FIELDS_LOCATIONS_BILLING`;
export const SET_FIELD_SUCCESS = `${CHECKOUT} SET_FIELD_SUCCESS`;
export const ADD_SHIPPING_RATES = `${CHECKOUT} ADD_SHIPPING_RATES`;
export const UPDATE_SHIPPING_RATES = `${CHECKOUT} UPDATE_SHIPPING_RATES`;
export const INCREASE_SHIPPING_RATES_COUNT = `${CHECKOUT} INCREASE_SHIPPING_RATES_COUNT`;
export const ADD_SHIPPING_BRANCHES = `${CHECKOUT} ADD_SHIPPING_BRANCHES`;
export const ADD_ADDRESS_FOR_BRANCH_SEARCH = `${CHECKOUT} ADD_ADDRESS_FOR_BRANCH_SEARCH`;
export const MAKE_PAYPALPLUS_PAYMENT = `${CHECKOUT} MAKE_PAYPALPLUS_PAYMENT`;

export const ADD_PROMOTION_COUPON = `${CHECKOUT} ADD_PROMOTION_COUPON`;
export const REMOVE_PROMOTION_COUPON = `${CHECKOUT} REMOVE_PROMOTION_COUPON`;

export const LOGIN = `${CHECKOUT} LOGIN`;
export const LOGOUT = `${CHECKOUT} LOGOUT`;
export const CREATE_ACCOUNT = `${CHECKOUT} CREATE_ACCOUNT`;

export const REVERSE_GEOCODE_LOCATION = `${CHECKOUT} REVERSE_GEOCODE_LOCATION`;
export const SHOW_ERROR = `${CHECKOUT} SHOW_ERROR`;

export const REMOVE_GIFT_CARD_CODE = `${CHECKOUT} REMOVE_GIFT_CARD_CODE`;

export const SET_FIELD_COLORS = `${CHECKOUT} SET_FIELD_COLORS`;

export const showError = (error) => ({
  type: SHOW_ERROR,
  payload: {
    error: error,
  },
});

export const loadedPage = (page) => ({
  type: LOADED_PAGE,
  payload: {
    page: page,
  },
});

export const addShippingRates = (rates) => ({
  type: ADD_SHIPPING_RATES,
  payload: {
    rates: rates,
  },
});

export const updateShippingRates = (rates) => ({
  type: UPDATE_SHIPPING_RATES,
  payload: {
    rates: rates,
  },
});

export const addShippingBranches = (branches) => ({
  type: ADD_SHIPPING_BRANCHES,
  payload: {
    branches: branches,
  },
});

export const addAddressForBranchSearch = (address) => ({
  type: ADD_ADDRESS_FOR_BRANCH_SEARCH,
  payload: {
    address: address,
  },
});

export const increaseShippingRatesCount = () => ({
  type: INCREASE_SHIPPING_RATES_COUNT,
  payload: {},
});

export const fetchDataInformation = (previewMode = false) => ({
  type: FETCH_DATA_INFORMATION,
  payload: {
    previewMode: previewMode,
  },
});

export const fetchDataShipping = () => ({
  type: FETCH_DATA_SHIPPING,
  payload: {},
});

export const fetchDataBilling = () => ({
  type: FETCH_DATA_BILLING,
  payload: {},
});

export const fetchDataPayment = () => ({
  type: FETCH_DATA_PAYMENT,
});

export const fetchPayments = (address) => ({
  type: FETCH_PAYMENTS,
  payload: { address: address },
});

export const fetchDataSuccess = () => ({
  type: FETCH_DATA_SUCCESS,
});

export const fetchShippingTypeRates = (type, address, date) => ({
  type: FETCH_SHIPPING_TYPE_RATES,
  payload: {
    type: type,
    address: address,
    date: date,
  },
});

export const fetchUpdatedShippingTypeRates = (type) => ({
  type: FETCH_UPDATED_SHIPPING_TYPE_RATES,
  payload: {
    type: type,
  },
});

export const fetchShippingTypeBranches = (type) => ({
  type: FETCH_SHIPPING_TYPE_BRANCHES,
  payload: {
    type: type,
  },
});

export const fetchAddressForBranchAddress = (address) => ({
  type: FETCH_ADDRESS_FOR_BRANCH_SEARCH,
  payload: {
    address: address,
  },
});

export const saveInformation = (url, body, previewMode, navigate) => ({
  type: SAVE_INFORMATION,
  payload: {
    body: body,
    url: url,
    previewMode,
    navigate,
  },
});

export const saveShipping = (url, body, navigate) => ({
  type: SAVE_SHIPPING,
  payload: {
    body: body,
    url: url,
    navigate,
  },
});

export const saveEmail = (url, body) => ({
  type: SAVE_EMAIL,
  payload: {
    body: body,
    url: url,
  },
});

export const savePhone = (url, body) => ({
  type: SAVE_PHONE,
  payload: {
    body: body,
    url: url,
  },
});

// TODO: Use this instead of the hardcoded action.
export const saveBilling = (url, body) => ({
  type: SAVE_BILLING,
  payload: {
    body: body,
    url: url,
  },
});

export const savePayment = (url, body) => ({
  type: SAVE_PAYMENT,
  payload: {
    body: body,
    url: url,
  },
});

export const placeOrder = (url, body) => ({
  type: PLACE_ORDER,
  payload: {
    url: url,
    body: body,
  },
});

export const setData = (data) => ({
  type: SET_DATA,
  payload: data,
});

export const setDataWithBranches = (data) => ({
  type: SET_DATA_WITH_BRANCHES,
  payload: data,
});

export const updateInformation = (data) => ({
  type: UPDATE_INFORMATION,
  payload: data,
});

export const updateShipping = (data) => ({
  type: UPDATE_SHIPPING,
  payload: data,
});

export const updateShippingOption = (data) => ({
  type: UPDATE_SHIPPING_OPTION,
  payload: data,
});

export const updateBilling = (data) => ({
  type: UPDATE_BILLING,
  payload: data,
});

export const updatePayment = (data) => ({
  type: UPDATE_PAYMENT,
  payload: data,
});

export const updateSummary = (data) => ({
  type: UPDATE_SUMMARY,
  payload: data,
});

export const updateLocations = (url, body) => ({
  type: UPDATE_LOCATIONS,
  payload: {
    body: body,
    url: url,
  },
});

export const callAddressAutofill = (url, body) => ({
  type: CALL_ADDRESS_AUTOFILL,
  payload: {
    body: body,
    url: url,
  },
});

export const setAddressAutofill = (data) => ({
  type: SET_ADDRESS_AUTOFILL,
  payload: data,
});

export const updatePaymentMethod = (body) => ({
  type: UPDATE_PAYMENT_METHOD,
  payload: body,
});

export const updateLocationsBilling = (url, body) => ({
  type: UPDATE_LOCATIONS_BILLING,
  payload: {
    body: body,
    url: url,
  },
});

export const updateCountry = (url, body) => ({
  type: UPDATE_COUNTRY,
  payload: {
    body: body,
    url: url,
  },
});

export const updateRegion = (url, body) => ({
  type: UPDATE_REGION,
  payload: {
    body: body,
    url: url,
  },
});

export const updateCountryBilling = (url, body) => ({
  type: UPDATE_COUNTRY_BILLING,
  payload: {
    body: body,
    url: url,
  },
});

export const updateRegionBilling = (url, body) => ({
  type: UPDATE_REGION_BILLING,
  payload: {
    body: body,
    url: url,
  },
});

export const setFieldInformation = (field, value) => ({
  type: SET_FIELD_INFORMATION,
  payload: {
    field: field,
    value: value,
  },
});

export const saveShippingOption = (url, value) => ({
  type: SAVE_SHIPPING_OPTION,
  payload: {
    url: url,
    body: {
      shipping_option: value,
    },
  },
});

export const setCustomFieldInformation = (field, value, area) => ({
  type: SET_CUSTOM_FIELD_INFORMATION,
  payload: {
    field: field,
    value: value,
    area: area,
  },
});

export const setFieldShipping = (field, value) => ({
  type: SET_FIELD_SHIPPING,
  payload: {
    field: field,
    value: value,
  },
});

export const getPickupPrice = (branch, service, prices_per_service) => ({
  type: GET_PICKUP_PRICE,
  payload: {
    body: {
      branch: branch,
      service: service,
      prices_per_service: prices_per_service,
    },
    url: "v2/checkout/pickup",
  },
});

export const getPickupPriceOld = (
  branch,
  name,
  service,
  country,
  region,
  municipality,
  postal,
) => ({
  type: GET_PICKUP_PRICE_OLD,
  payload: {
    body: {
      branch: branch,
      name: name,
      service: service,
      country: country,
      region: region,
      municipality: municipality,
      postal: postal,
    },
    url: "v2/checkout/pickup",
  },
});

export const setFieldPayment = (field, value) => ({
  type: SET_FIELD_PAYMENT,
  payload: {
    field: field,
    value: value,
  },
});

export const setFieldColors = (field, value) => ({
  type: SET_FIELD_COLORS,
  payload: {
    field: field,
    value: value,
  },
});

export const setFieldSuccess = (field, value) => ({
  type: SET_FIELD_SUCCESS,
  payload: {
    field: field,
    value: value,
  },
});

export const setFieldsLocations = (data) => ({
  type: SET_FIELDS_LOCATIONS,
  payload: data,
});

export const setFieldBilling = (field, value) => ({
  type: SET_FIELD_BILLING,
  payload: {
    field: field,
    value: value,
  },
});

export const makePaypalPlusPayment = (url, url_order, body) => ({
  type: MAKE_PAYPALPLUS_PAYMENT,
  payload: {
    body: body,
    url_order: url_order,
    url: url,
  },
});

export const setFieldsLocationsBilling = (data) => ({
  type: SET_FIELDS_LOCATIONS_BILLING,
  payload: data,
});

export const addPromotionCoupon = (coupon_data, customer_email) => ({
  type: ADD_PROMOTION_COUPON,
  payload: {
    body: {
      codes: coupon_data,
      customer_email,
    },
    url: "v2/checkout/promotions",
  },
});

export const removePromotionCoupon = (code) => ({
  type: REMOVE_PROMOTION_COUPON,
  payload: {
    id: code,
  },
});

export const logout = (url) => ({
  type: LOGOUT,
  payload: {
    url: url,
  },
});

export const login = (url) => ({
  type: LOGIN,
  payload: {
    url: url,
  },
});

export const reverseGeocodeLocation = (url, body) => ({
  type: REVERSE_GEOCODE_LOCATION,
  payload: {
    body: body,
    url: url,
  },
});

export const makeRequest = (options) => ({
  type: options.feature,
  payload: options,
});

export const removeGiftCardCode = (id) => ({
  type: REMOVE_GIFT_CARD_CODE,
  payload: {
    id: id,
  },
});
